module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_12-7bfb6231970f029d12c24d53d38fe010.png";